import { browser } from '$app/environment';

/** scroll view to top of window or of target html element */
export const scrollToTop = (target?: HTMLElement): void => {
	if (!browser) return;

	if (!target) return document.body.scrollIntoView();

	// scroll to top of target element
	target.scrollIntoView();
};
